export const allowedFileTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
export const sheetFileTypes = [
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'xlsx'
];
